<!--Шаблон для отображения политики поролей-->
<template>
  <v-alert type="info" variant="outlined" v-if="policy">
    <p class="font-weight-bold">Текущая парольная политика</p>
    <p>• {{ policy.pwdProperties }}</p>
    <p>• Минимальная длина пароля: {{ policy.minPwdLength }} символов</p>
    <p>• Новый пароль не должен соответствовать {{ policy.pwdHistoryLength }}
      {{ getWordDeclension(policy.pwdHistoryLength, 'последнему паролю', 'последним паролям', 'последним паролям') }}</p>
    <template v-if="showAll">
      <p>• Максимальный срок жизни пароля: {{ policy.maxPwdAge }}
        {{ getWordDeclension(policy.maxPwdAge, 'день', 'дня', 'дней') }}</p>
      <p>• Минимальный срок жизни пароля: {{ policy.minPwdAge }}
        {{ getWordDeclension(policy.minPwdAge, 'день', 'дня', 'дней') }}</p>
      <p>• Максимальное количество попыток ввода пароля подряд: {{ policy.lockoutThreshold }}
        {{ getWordDeclension(policy.lockoutThreshold, 'раз', 'раза', 'раз') }}</p>
      <p>• Время блокировки аккаунта после превышения максимального количества попыток ввода пароля: {{ policy.lockoutDuration }}
        {{ getWordDeclension(policy.lockoutDuration, 'минута', 'минуты', 'минут') }}</p>
    </template>
  </v-alert>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { getWordDeclension } from "@/helper";

export default {
  name: "PasswordPolicyInfo",
  props: {
    showAll: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters({
      policy: 'auth/getPasswordPolicy'
    })
  },
  methods: {
    getWordDeclension,
    ...mapActions({
      loadPolicy: 'auth/loadPasswordPolicy'
    })
  },
  mounted () {
    /**
     * При монтировании политики загружает данные о политике поролей
     */
    if (this.policy) return
    this.loadPolicy()
  }
}
</script>

<style scoped>

</style>
